import { getMedicationsRequest } from 'api/FHIR/api';
import { MedicationStatement } from 'api/FHIR/types';
import { MedicationsFilter } from 'common/types/SearchParams';
import { Pagination } from 'common/types/Pagination';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import omit from 'lodash/omit';
import { camelizeKeys } from 'humps';

const useGetMedications = (userId: string) => {
  const { t } = useTranslation();

  const [ medications, setMedications ] = useState<MedicationStatement[]>([]);
  const [ pagination, setPagination ] = useState<Pagination | undefined>();
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const getMedications = useCallback((filters: MedicationsFilter, abortController: AbortController) => {
    setIsLoading(true);
    setError('');

    getMedicationsRequest(userId, filters, abortController)
      .then((response) => {
        setMedications(camelizeKeys(response.data.results) as MedicationStatement[]);
        setPagination(omit(response.data, 'results'));
      })
      .catch((error) => {
        if (!abortController?.signal.aborted) {
          setError(error?.response?.data?.message || t('errors.server_error_try_again'));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, [ t, userId ]);

  return { getMedications, medications, isLoading, error, pagination };
};

export default useGetMedications;
